export const LAYOUT = 'layout';
export const PAGE = 'page';
